export const MAX_UPLOAD_FILES = 20;
export const MAX_UPLOAD_FILE_SIZE_BYTES = 200 * 1024 * 1024;

export const validateUploadFiles = files => {
  const filesArray = Array.from(files || []);

  if (filesArray.length > MAX_UPLOAD_FILES) {
    return `You can upload a maximum of ${MAX_UPLOAD_FILES} files at a time.`;
  }

  const oversizedFiles = filesArray.filter(file => file.size > MAX_UPLOAD_FILE_SIZE_BYTES);

  if (oversizedFiles.length > 0) {
    const fileNames = oversizedFiles
      .slice(0, 3)
      .map(file => file.name)
      .join(', ');
    const extraCount = oversizedFiles.length > 3 ? ` and ${oversizedFiles.length - 3} more` : '';

    return `Files must be 200 MiB (approximately 210 MB) or smaller. Remove: ${fileNames}${extraCount}.`;
  }

  return null;
};
